<template>
	<v-footer class="bg-teal-lighten-3 text-center d-flex flex-column justify-end footer pt-">
		<div>
			©{{ new Date().getFullYear() }} — <strong @click="onClick('https://livereader.com')">LiveReader</strong>
		</div>
	</v-footer>
</template>

<script setup lang="ts">
function onClick(href: string) {
	window.open(href, "_blank");
}
</script>

<style scoped lang="scss">
.footer {
	background-color: #55d04d !important;
}

.footer strong {
	cursor: pointer;
}
</style>
